<template>
  <span>

    <div class="ItemTreeFolder">

      <li>
        <div class="treeline">
          <div class="expand__container">
            <img class="expandimage" v-if="isFolder !== undefined && open == false && model.children.length > 0"
              @click="toggle" src="/static/branch-collapsed.png">


            <img class="expandimage" v-if="isFolder !== undefined && open == true && model.children.length > 0"
              @click="toggle" src="/static/branch-expanded-dark.png">


            <img class="expandimage" v-if="!isFolder" src="/static/transparent_icon_24.png">
          </div>

          <span v-if="model.type === 'folder'&&!model.isVariant" class="folder"></span>
          <span v-if="model.type === 'folder'&&model.isVariant" class="folder-variant" v-b-tooltip.hover.topleft
            :title="model.variantName"></span>
          <!-- <span v-if="model.type !== 'folder'" class="nofolder"></span> -->
          <img v-if="model.type !== 'folder'" width=16px :src="filenameToIcon(model.name)">


          <a v-if="model.type === folder && model.delegatedFolder === false && isOwnerOfDelegation == false"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)">{{model.name}}
          </a>
          <a v-if="model.type === folder && model.delegatedFolder === true && isOwnerOfDelegation == false && currentUser.userId !== model.delegatedUserId && isOwner == false"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)" v-b-tooltip.hover.topright
            :title="'delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{model.name}} | <b-badge
              class="badge-delegate" variant="danger">D
            </b-badge>
          </a>
          <a v-if="model.type === folder && model.delegatedFolder === true && isOwnerOfDelegation == true && isOwner == false"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)" v-b-tooltip.hover.topright
            :title="'delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{model.name}} | <b-badge
              class="badge-delegate" variant="success">D</b-badge>
          </a>
          <a v-if="model.type === folder && model.delegatedFolder === true && isOwnerOfDelegation == false && isOwner == true"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)" v-b-tooltip.hover.topright
            :title="'delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{model.name}} | <b-badge
              class="badge-delegate" variant="danger">D</b-badge>
          </a>



          <a v-if="model.type !== folder" v-show="model.delegatedFile === false && isOwnerOfDelegation == false"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)" v-b-tooltip.hover.topright
            :title="model.fileSize + ' | ' + modificationDate ">{{ shorterName }}<span v-show="model.fileRevision!=0"> |
            </span>
            <b-badge class="badge-file-rev" variant="primary" v-show="model.fileRevision!=0">{{model.fileRevision}}
            </b-badge>

          </a>
          <a v-if="model.type !== folder"
            v-show="model.delegatedFile == true && isOwnerOfDelegation == false && currentUser.userId !== model.delegatedUserId && isOwner == false"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)" v-b-tooltip.hover.topright
            :title="model.fileSize + ' | ' + modificationDate + ' | delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{ shorterName }}<span
              v-show="model.fileRevision!=0"> |
            </span>
            <b-badge class="badge-file-rev" variant="primary" v-show="model.fileRevision!=0">{{model.fileRevision}}
            </b-badge>
            <b-badge class="badge-delegate" variant="danger">D</b-badge>

          </a>
          <a v-if="model.type !== folder"
            v-show="model.delegatedFile == true && isOwnerOfDelegation == true && isOwner == false"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)" v-b-tooltip.hover.topright
            :title="model.fileSize + ' | ' + modificationDate + ' | delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{ shorterName }}<span
              v-show="model.fileRevision!=0"> |
            </span>
            <b-badge class="badge-file-rev" variant="primary" v-show="model.fileRevision!=0">{{model.fileRevision}}
            </b-badge>
            <b-badge class="badge-delegate" variant="success">D</b-badge>
          </a>
          <a v-if="model.type !== folder"
            v-show="model.delegatedFile == true && isOwnerOfDelegation == false && isOwner == true"
            class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
            @click="selectResource(revisionId)" v-b-tooltip.hover.topright
            :title="model.fileSize + ' | ' + modificationDate + ' | delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{ shorterName }}<span
              v-show="model.fileRevision!=0"> |
            </span>
            <b-badge class="badge-file-rev" variant="primary" v-show="model.fileRevision!=0">{{model.fileRevision}}
            </b-badge>
            <b-badge class="badge-delegate" variant="danger">D</b-badge>
          </a>

          <div class="action-buttons">
            <b-dropdown v-show="isActive" size="sm" class="dropdown-more" :variant="variant" right text="More">
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.type == 'folder' && isPending && isOwner && isDelegated == false && isLastRevision ==true"
                :id="'id_'+itemId + '_' + revisionId" @click="createItem(model.id)">{{lang.button_CreateSubfolder}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.type == 'folder' && isPending && isDelegatedReject == true && isLastRevision == true"
                :id="'id_'+itemId + '_' + revisionId" @click="createItem(model.id)">{{lang.button_CreateSubfolder}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.type == 'folder' && isPending && isOwner && isDelegated == false && isLastRevision == true"
                :id="'id_'+itemId + '_' + revisionId" @click="importItem(model.id)">{{lang.button_ImportFile}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.type == 'folder' && isPending && isLastRevision == true && isOwner == false && isOwnerOfDelegation == false && isNotDelegatedAndIsParent == true"
                :id="'id_'+itemId + '_' + revisionId" @click="importItem(model.id)">{{lang.button_ImportFile}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.type == 'folder' && isPending && isLastRevision == true && isOwner == false && isOwnerOfDelegation == true && isNotDelegatedAndIsParent == true"
                :id="'id_'+itemId + '_' + revisionId" @click="importItem(model.id)">{{lang.button_ImportFile}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                  v-if="model.type == 'folder' && isPending && isLastRevision == true && isOwner == false && isOwnerOfDelegation == true && isNotDelegatedAndIsParent == false"
                  :id="'id_' + itemId + '_' + revisionId" @click="importItem(model.id)">{{ lang.button_ImportFile }}
                </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder" v-if="edit" :id="'id_'+itemId + '_' + revisionId"
                @click="downloadItem(model.id)">{{lang.button_Download}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.name != 'Root' && isPending && isOwner && isDelegated == false && isLastRevision == true"
                :id="'id_'+itemId + '_' + revisionId" @click="deleteItem(model)">{{lang.button_Delete}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.name != 'Root' && isPending && isDelegatedButNotParent == true && isLastRevision == true && isOwner == false && isOwnerOfDelegation == true"
                :id="'id_'+itemId + '_' + revisionId" @click="deleteItem(model)">{{lang.button_Delete}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="isDelegated == false && isPending &&  isOwner && isLastRevision == true"
                :id="'id_'+itemId + '_' + revisionId" @click="delegateItem(model)">{{lang.button_Delegate}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="isDelegatedUndo == true && isPending && isOwner == true && isLastRevision == true && isDelegatedButNotParent == false && model.delegatedChild == false"
                :id="'id_'+itemId + '_' + revisionId" @click="undoDelegateItem(model)">{{ lang.button_UndoDelegate }}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="isDelegatedReject == true && isPending && isLastRevision == true && isDelegatedButNotParent == false && model.delegatedChild == false"
                :id="'id_'+itemId + '_' + revisionId" @click="rejectDelegateItem(model)">{{lang.button_RejectDelegate}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="isDelegatedCommit == true && isPending && isLastRevision == true && isDelegatedButNotParent == false && model.delegatedChild == false"
                :id="'id_'+itemId + '_' + revisionId" @click="confirmDelegateItem(model)">
                {{lang.button_ConfirmResource}}
              </b-dropdown-item>
              <!-- <b-dropdown-item class="actionButtonFolder"
                v-if="isBom == false && model.type == 'folder' && isPending && !model.isVariant && isOwner && isDelegated == false && isLastRevision == true"
                :id="'id_'+itemId + '_' + revisionId" @click="setAsVariant(model.id)">{{lang.button_SetAsBomCore}}
              </b-dropdown-item> -->
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.type == 'folder' && isPending && !model.isVariant && isOwner && isDelegated == false && isLastRevision == true"
                :id="'id_'+itemId + '_' + revisionId" @click="setAsVariant(model.id)">{{lang.button_SetAsVariant}}
              </b-dropdown-item>
              <b-dropdown-item class="actionButtonFolder"
                v-if="model.type == 'folder' && isPending && model.isVariant && isOwner && isDelegated == false && isLastRevision == true"
                :id="'id_'+itemId + '_' + revisionId" @click="removeAsVariant(model.id)">{{lang.button_RemoveAsVariant}}
              </b-dropdown-item>
            </b-dropdown>
            <!-- <b-button-group size="sm" v-if="false">
              <b-button v-show="showButton" size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton" v-if="model.type=='folder'&&isPending&&isOwner"
                :id="'id_'+itemId + '_' + revisionId" @click="createItem(model.id)">{{lang.button_CreateSubfolder}}
              </b-button>
              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton" v-if="model.type=='folder'&&isPending&&isOwner"
                :id="'id_'+itemId + '_' + revisionId" @click="importItem(model.id)">{{lang.button_ImportFile}}
              </b-button>
              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton" v-if="edit" :id="'id_'+itemId + '_' + revisionId"
                @click="downloadItem(model.id)">{{lang.button_Download}}
              </b-button>
              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 deleteButton" v-if="model.name!='Root'&&isPending&&isOwner"
                :id="'id_'+itemId + '_' + revisionId" @click="deleteItem(model)">{{lang.button_Delete}}
              </b-button>

              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton" v-if="isDelegated == true"
                :id="'id_'+itemId + '_' + revisionId" @click="delegateItem(model)">{{lang.button_Delegate}}
              </b-button>

              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton" v-if="isDelegatedUndo == true"
                :id="'id_'+itemId + '_' + revisionId" @click="undoDelegateItem(model)">{{lang.button_UndoDelegate}}
              </b-button>

              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton" v-if="isDelegatedReject == true"
                :id="'id_'+itemId + '_' + revisionId" @click="rejectDelegateItem(model)">{{lang.button_RejectDelegate}}
              </b-button>

              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton" v-if="isDelegatedCommit == true"
                :id="'id_'+itemId + '_' + revisionId" @click="confirmDelegateItem(model)">
                {{lang.button_ConfirmResource}}
              </b-button>


              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton"
                v-if="model.type=='folder'&&isPending&&!model.isVariant&&isOwner" :id="'id_'+itemId + '_' + revisionId"
                @click="setAsVariant(model.id)">{{lang.button_SetAsVariant}}
              </b-button>
              <b-button v-show="showButton" v-b-tooltip.hover.left size="sm" type="submit" :variant="variant"
                class="actionButtonFolder my-2 my-sm-0 delegateButton"
                v-if="model.type=='folder'&&isPending&&model.isVariant&&isOwner" :id="'id_'+itemId + '_' + revisionId"
                @click="removeAsVariant(model.id)">{{lang.button_RemoveAsVariant}}
              </b-button>
              


            </b-button-group> -->
          </div>
        </div>

        <ul v-show="open" v-if="isFolder" class="library_ul">
          <ItemTreeFolder :isPending="isPending" :revisionId="revisionId" :action="action" class="library_item"
            :lang="lang" v-for="model in model.children" :model="model" :edit="edit" :key="model.folderId"
            :isLastRevision="isLastRevision" :ownerOfLastRevision="ownerOfLastRevision" >
          </ItemTreeFolder>
        </ul>




      </li>
    </div>

  </span>
</template>

<script>

import { mapGetters } from 'vuex'
import * as Tools from './../../Tools/Tools'

export default {
  name: 'ItemTreeFolder',
  props: {
    model: Object,
    edit: Boolean,
    lang: Object,
    action: Boolean,
    revisionId: Number,
    isPending: Boolean,
    isLastRevision: Boolean,
    ownerOfLastRevision: Number
  },
  data: function () {
    return {
        open: true,
        folder: "folder",
        showButton: false,
        
        
        
        objAlertSuccess: {
          text: this.lang.alert_success_delete_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

        },
        objAlertError:{
          text:this.lang.alert_error_delete_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
        },
        

    };
  },
  computed: {
    ...mapGetters({

      currentUser: 'currentUser',
      
    }),
    
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
    isOwner(){
          
      return this.ownerOfLastRevision == this.$store.getters.currentUser.userId;
    },
    itemId(){
     if (this.model.type == "folder"){
        
        return this.model.folderId;
      }
      
      if (this.model.type == "file"){
        
        return this.model.fileId;
      }
    },
    modificationDate(){
      return Tools.longDateToShort(this.model.modificationDate);
    }, 
    delegatedDate() {
      return Tools.longDateToShort(this.model.delegatedDate);
    },
    isFolder: function () {
      
      if (this.model.children == undefined){
        return
      
      }
      return this.model.children.length > 0;
    },
    isActive(){
      
      
      if (this.$store.getters.selectedTreeFolderItemObject.type == "folder"){
        
        return this.$store.getters.selectedTreeFolderItemObject.folderId == this.model.folderId;
      }
      
      if (this.$store.getters.selectedTreeFolderItemObject.type == "file"){
        
        return this.$store.getters.selectedTreeFolderItemObject.fileId == this.model.fileId;
      }
      
      return ""
    },
    uid(){

      return this._uid
    },
    classObject(){
      return {
        active: this.isActive
      }
    },
    isDelegated() {
      let res = false;
      if (this.isOwner && this.isPending) {
        if (this.model.type == "folder") {
          
          if (this.model.delegatedFolder == false) {
            res = false;
          } else {
            res = true;
          }
          
        } else if (this.model.type == "file") {
          if (this.model.delegatedFile == false) {
            res = false;
          } else {
            res = true;
          }
        }
      

      }
      
      return res;
    },
    isDelegatedReject() {
      let res = false;
      
        if (this.model.type == "folder") {

          if (this.model.delegatedFolder == true) {
            if (this.model.delegatedUserId == this.currentUser.userId && this.isOwner == false && this.isPending) {
              res = true;
            } 
          } 

        } else if (this.model.type == "file") {
          if (this.model.delegatedFile == true) {
            if (this.model.delegatedUserId == this.currentUser.userId && this.isOwner == false && this.isPending) {
              res = true;
            } 
          } 
        }


      
      return res;
    },
    isDelegatedUndo() {
      let res = false;
      if (this.isOwner == true && this.isPending) {
        if (this.model.type == "folder") {

          if (this.model.delegatedFolder == true) {
            res = true;
          } else {
            res = false;
          }

        } else if (this.model.type == "file") {
          if (this.model.delegatedFile == true) {
            res = true;
          } else {
            res = false;
          }
        }


      }
      return res;
    },
    isDelegatedCommit() {
      let res = false;
      if (this.model.delegatedUserId == this.currentUser.userId && this.isOwner == false && this.isPending) {
        if (this.model.type == "folder") {

          if (this.model.delegatedFolder == true) {
            res = true;
          } else {
            res = false;
          }

        } else if (this.model.type == "file") {
          if (this.model.delegatedFile == true) {
            res = true;
          } else {
            res = false;
          }
        }


      }
      return res;
    },
    isDelegatedButNotParent() {
      let isDelegatedResource = false;
      
        if (this.model.type == "folder") {

          if (this.model.delegatedFolder == true) {
            isDelegatedResource = true;
          } else {
            isDelegatedResource = false;
          }

        } else if (this.model.type == "file") {
          if (this.model.delegatedFile == true) {
            isDelegatedResource = true;
          } else {
            isDelegatedResource = false;
          }
        }


      
      if (isDelegatedResource == true && this.model.delegatedChild == true) {
        return true;
      }
      return false;
    },
    isNotDelegatedAndIsParent() {
      
      let trig = false;
      if (this.model.children != undefined) {
        for (let i = 0, lei = this.model.children.length; i < lei; i++) {
          
          if (this.model.children[i].delegatedFile == true && this.model.children[i].delegatedUserId == this.currentUser.userId) {
            trig = true;
          }
        }
      }
      // if (this.model.delegatedFolder == true && this.model.delegatedChild == false) {
      //   return true;
      // }
      return trig;
    },
    isOwnerOfDelegation() {
      if (this.model.delegatedUserId == this.currentUser.userId) {
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_delegatedResource", true);
        
        return true;
      }
      return false;
    },
    isBom() {
      return this.$store.getters.isBom;
    },
    shorterName() {
      let str = this.model.name;
      if (this.model.name != undefined) {
        
        
        let first = this.model.name.substr(0, 20);
        let second = this.model.name.substr(this.model.name.length - 20, 20);
        if (this.model.name.length > 50) {
          str = first + "..." + second;
        }
      }
       
      return str;
    }

  },
  mounted () {

  },
  updated() {
    
  },
  watch: {
    
  },
  methods: {
      filenameToIcon(data){
        return Tools.filenameToIcon(data)
      },
      toggle: function () {
        
          if (this.isFolder) {
              this.open = !this.open;
          }

      },
      setAsVariant(){


        let vue = this;
        let folderId = vue.model.folderId;
        
        
        let funcYes = function(e){
          
          const form = vue.$store.getters.subfolderForm;

          
          if (form.name == undefined) {

            let obj = {
              text: vue.lang.alert_error_create_variant_no_name,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
            return
          }

          const obj = {
            folderId: folderId,
            projectRevisionId: vue.revisionId,
            name: form.name
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_mapFolderToVariant", obj)
          .then(function(result) {
            
            console.log(result)

            if (result.status == "OK"){

              if (result.data != null){

                let obj = {
                  text: vue.lang.alert_success_create_variant,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", true )
            
                const reloadObj = {
                    status: true,
                  name: "BomsProjectTableComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              }else{

                let obj = {
                  text: vue.lang.alert_error_create_variant + ".",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }

            }else{

              let obj = {
                text: vue.lang.alert_error_create_variant + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }

            

          })

          

          
        }

        const obj = {
          
          text: "",
          type: "create_subfolder_project",
          buttons: 2,
          size: "lm",
          lang: this.lang.modal_SetAsVariant,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);

      },
      removeAsVariant(){


        let vue = this;
        let folderId = vue.model.folderId;
        
        let funcYes = function(e){
          
          const form = vue.$store.getters.subfolderForm;

          const obj = {
            folderId: folderId,
            projectRevisionId: vue.revisionId,
            
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_unmapFolderFromVariant", obj)
          .then(function(result) {
            
            console.log(result)

            if (result.status == "OK"){

              if (result.data != null){

                let obj = {
                  text: vue.lang.alert_success_remove_variant,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", true )
            
                const reloadObj = {
                  status: true,
                  name: "BomsProjectTableComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              }else{

                let obj = {
                  text: vue.lang.alert_error_remove_variant + ".",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }

            }else{

              let obj = {
              text: vue.lang.alert_error_remove_variant + ": " + result.message,
              time: 15,
              type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }

            

          })

          

          
        }

        let obj = {
          title: vue.lang.alerttitle_RemoveVariant,
          text: vue.lang.alertinfo_1,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcNo: "",
          funcYes: funcYes
        };
        vue.$store.dispatch("showAlert", obj);

        

      },
      createItem(){
        

        

        let vue = this;
        let folderId = vue.model.folderId;
        

        let funcYes = function(e){
          
          const form = vue.$store.getters.subfolderForm;
          
          if (form.name == undefined) {

            let obj = {
              text: vue.lang.alert_error_create_folder_no_name,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
            return
          }

          const obj = {
            folderId: folderId,
            name: form.name
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_createFolder", obj)
          .then(function(result) {
            
            console.log(result)

            if (result.status == "OK"){

              if (result.data != null){

                let obj = {
                  text: vue.lang.alert_success_create_folder,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", true )

              }else{

                let obj = {
                  text: vue.lang.alert_error_create_folder + ".",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }

            }else{

              let obj = {
                text: vue.lang.alert_error_create_folder + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }

           

            

          })

          

          
        }

        const obj = {
          
          text: "",
          type: "create_subfolder_project",
          buttons: 2,
          size: "lm",
          lang: this.lang.modal_CreateFolder,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);


      },
      importItem(){


        let vue = this;
        let folderId = vue.model.folderId;
        
 
        let funcYes = function(e){
          vue.$store.dispatch("showLoader", { visible: true, text: "load" });
          const form = vue.$store.getters.variantFolderForm;

          //console.log(1, form.file.lastModified)
          //Tools.IntegerToIntegerUTC(form.file.lastModified);
          //console.log(1, form.file.lastModified)

          const obj = {
            folderId: folderId,
            projectRevisionId: vue.revisionId,
            file: form.file,
            modDate: Tools.IntegerToIntegerUTC(form.file.lastModified)
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_importDocument", obj)
          .then(function(result) {
            
            console.log(result)

            vue.$store.dispatch("showLoader", { visible: false });

            if (result.status == "OK"){

              if (result.data != null){

                let obj = {
                  text: vue.lang.alert_success_import_file,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", true );

                const reloadObj = {
                  status: true,
                  name: "BomsProjectTableComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              }else{

                let obj = {
                  text: vue.lang.alert_error_import_file + ".",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }

            }else{

              let obj = {
                text: vue.lang.alert_error_import_file + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }

            
          })
          .then(function () {

            vue.$store.dispatch("showLoader", { visible: false });

          })
          

          
        }

        const obj = {
          
          text: "",
          type: "import_file_tree",
          buttons: 2,
          size: "lm",
          lang: this.lang.modal_ImportFile,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);



      },
      downloadItem(){


        let vue = this;

        if (this.model.type == "folder"){
          const obj = {
            folderId: vue.model.folderId,
            
          }
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProjectFiles", obj)
            .then(function(result) {

              console.log(result)

              

                if (result.size != null||result.size != undefined){

                  
                  let fileName = vue.model.name + ".zip";

                  var a = document.createElement("a");
                  a.href = URL.createObjectURL(result);
                  a.download = fileName;
                  
                  document.body.appendChild(a);
                  
                  a.click();
                  document.body.removeChild(a);

                  let obj = {
                    text: vue.lang.alert_success_download_file,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);

                

              }else{

                let obj = {
                  text: vue.lang.alert_error_download_file + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

              

          })

        }else{
          const obj = {
            documentId: vue.model.fileId,
            revisionId: vue.revisionId
          }
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_downloadFile", obj)
            .then(function(result) {

                           

                if (result.size != null||result.size != undefined){

                  let fileName = vue.model.name;

                  var a = document.createElement("a");
                  a.href = URL.createObjectURL(result);
                  a.download = fileName;
                  
                  document.body.appendChild(a);
                  
                  a.click();
                  document.body.removeChild(a);

                  let obj = {
                    text: vue.lang.alert_success_download_file,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);

                }else{

                  let obj = {
                    text: vue.lang.alert_error_download_file + ": " + result.message,
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);

                }

              

            
              

          })
        }
        

      },
      deleteItem: function(model){


        let vue = this;

        if (this.model.type == "folder"){


          const obj = {
              folderId: this.model.folderId
          }
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_checkIfItemsInFolder", obj)
          .then(function(result) {
            
            if (result.data > 0){
              vue.deleteWithItems(result.data);
            }else{
              vue.deleteFolder();

            }

          })

        }else if(this.model.type == "file"){

          
          let fileId = vue.model.fileId;
        

          let deleteFunc = function(){ 

          const obj = {
            fileId: vue.model.fileId, 
            
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteDocument", obj)
          .then((result) => {

            console.log(result)

            if (result.status == "OK"){

              if (result.data != null){

                let obj = {
                  text: vue.lang.alert_success_delete_file,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }else{

                let obj = {
                  text: vue.lang.alert_error_delete_file + ".",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }

            }else{

              let obj = {
                text: vue.lang.alert_error_delete_file + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", true )


            const reloadObj = {
              status: true,
              name: "BomsProjectTableComponent"
            }
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

          });
            
        }
          


        let obj = {
          title: vue.lang.alerttitle_Delete,
          text: vue.lang.alertinfo_1,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcNo: "",
          funcYes: deleteFunc
        };
        vue.$store.dispatch("showAlert", obj);
            
        }



      },
      
      deleteFolder: function(){
        
        let vue = this;

        let deleteFunc = function(){ 

          const obj = {
            folderId: vue.model.folderId, 
            
          }
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteFolder", obj)
          .then((result) => {

            console.log(result)

            if (result.status == "OK"){

              if (result.data != null){

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", true );

                let obj = {
                  text: vue.lang.alert_success_delete_folder,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }else{

                let obj = {
                  text: vue.lang.alert_error_delete_folder + ".",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

              }

            }else{

              let obj = {
                text: vue.lang.alert_error_delete_folder + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }

            
            
          });
            
        }
          


        let obj = {
          title: vue.lang.alerttitle_Delete,
          text: vue.lang.alertinfo_1,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcNo: "",
          funcYes: deleteFunc
        };
        vue.$store.dispatch("showAlert", obj);
         
        
      },
      deleteWithItems: function(qty){
        

        let vue = this;
        
        let deleteFunc = function(){
            const obj = {
                folderId: vue.model.folderId, 
                //objAlertSuccess: vue.objAlertSuccess, 
                //objAlertError: vue.objAlertError,
               
            }
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteFolder", obj)
            .then((result) => {

              console.log(result)

              if (result.status == "OK"){

                if (result.data != null){

                  vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem", true );

                  let obj = {
                    text: vue.lang.alert_success_import_file,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);

                }else{

                  let obj = {
                    text: vue.lang.alert_error_import_file + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);

                }

              }else{

                let obj = {
                  text: vue.lang.alert_error_import_file + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }
              
            })
            

        }
          
         
        
        
        let obj = {
          title: vue.lang.alerttitle_Delete,
          text: vue.lang.alertinfo_2 + qty + vue.lang.alertinfo_3,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcNo: "",
          funcYes: deleteFunc
        };
        
        vue.$store.dispatch("showAlert", obj);
    },
    
    
    delegateItem(model) {
      

      let vue = this;

      if (this.model.type == "folder") {

        let folderId = this.model.folderId;

        let funcYes = function (e) {

          let delegationForm = vue.$store.getters.delegationForm;

          if (delegationForm.userId == null) {
            let obj = {
              text: vue.lang.alert_error_DelegateUser,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
            return
          }


          let obj = {
            folderId: folderId,
            userId: delegationForm.userId
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_delegateFolder", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_DelegateFolder,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_DelegateFolder + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_DelegateFolder + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        var obj = {

          text: "",
          type: "delegation",
          buttons: 2,
          size: "lg",
          lang: this.lang.modal_Delegation,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);

      } else if (this.model.type == "file") {

        let fileId = this.model.fileId;

        let funcYes = function (e) {

          let delegationForm = vue.$store.getters.delegationForm;
          
          if (delegationForm.userId == null) {
            let obj = {
              text: vue.lang.alert_error_DelegateUser,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
            return
          }


          let obj = {
            fileId: fileId,
            userId: delegationForm.userId
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_delegateFile", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_DelegateFile,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_DelegateFile + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_DelegateFile + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        var obj = {

          text: "",
          type: "delegation",
          buttons: 2,
          size: "lg",
          lang: this.lang.modal_Delegation,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);
      }

      
    },
    undoDelegateItem() {
      let vue = this;

      

      if (this.model.type == "folder") {

        let folderId = this.model.folderId;

        let funcYes = function (e) {

          //let delegationForm = vue.$store.getters.delegationForm;


          let obj = {
            folderId: folderId,
            
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_undoDelegateFolder", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_UndoDelegateFolder,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_UndoDelegateFolder + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_UndoDelegateFolder + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        
        const obj = {
          title: this.lang.title_UndoDelegate,
          text: this.lang.infotext_UndoDelegate,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcYes: funcYes,
          funcNo: ""
        };

        this.$store.dispatch("showAlert", obj);

      } else if (this.model.type == "file") {

        let fileId = this.model.fileId;

        let funcYes = function (e) {

          
          let obj = {
            fileId: fileId,
            
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_undoDelegateFile", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_UndoDelegateFile,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_UndoDelegateFile + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_UndoDelegateFile + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        

        const obj = {
          title: this.lang.title_UndoDelegate,
          text: this.lang.infotext_UndoDelegate,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcYes: funcYes,
          funcNo: ""
        };

        this.$store.dispatch("showAlert", obj);
      }
    },
    rejectDelegateItem() {
      let vue = this;
      
      

      if (this.model.type == "folder") {

        let folderId = this.model.folderId;

        let funcYes = function (e) {

          let delegationForm = vue.$store.getters.delegationForm;
          
          let obj = {
            folderId: folderId,
            reason: delegationForm.reason
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_rejectDelegationFolder", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_RejectDelegateFolder,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_RejectDelegateFolder + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_RejectDelegateFolder + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        var obj = {

          text: "",
          type: "delegation",
          buttons: 2,
          size: "lg",
          lang: this.lang.modal_RejectDelegation,
          funcNo: "",
          funcYes: funcYes
        };
        
        this.$store.dispatch("showModalComponent", obj);

      } else if (this.model.type == "file") {

        let fileId = this.model.fileId;

        let funcYes = function (e) {

          let delegationForm = vue.$store.getters.delegationForm;

          let obj = {
            fileId: fileId,
            reason: delegationForm.reason
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_rejectDelegationFile", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_RejectDelegateFile,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_RejectDelegateFile + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_RejectDelegateFile + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        var obj = {

          text: "",
          type: "delegation",
          buttons: 2,
          size: "lg",
          lang: this.lang.modal_RejectDelegation,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);
      }
    },
    confirmDelegateItem() {
      let vue = this;

      if (this.model.type == "folder") {

        let folderId = this.model.folderId;

        let funcYes = function (e) {

          


          let obj = {
            folderId: folderId,
            
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_confirmResourceFolder", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_CommitDelegateFolder,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_CommitDelegateFolder + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_CommitDelegateFolder + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        const obj = {
          title: this.lang.title_CommitDelegate,
          text: this.lang.infotext_CommitDelegate,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcYes: funcYes,
          funcNo: ""
        };

        this.$store.dispatch("showAlert", obj);

      } else if (this.model.type == "file") {

        let fileId = this.model.fileId;

        let funcYes = function (e) {

          


          let obj = {
            fileId: fileId,
            
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_confirmResourceFile", obj)
            .then(function (result) {

              console.log(result)

              if (result.status == "OK") {



                if (result.data != null) {

                  let obj = {
                    text: vue.lang.alert_success_CommitDelegateFile,
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);


                  //reload table
                  const reloadObj = {
                    status: true,
                    name: "ProjectRevisionHistoryComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: vue.lang.alert_error_CommitDelegateFile + ".",
                    time: 15,
                    type: "danger"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                }

              } else {
                let obj = {
                  text: vue.lang.alert_error_CommitDelegateFile + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }


            })

        }

        const obj = {
          title: this.lang.title_CommitDelegate,
          text: this.lang.infotext_CommitDelegate,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcYes: funcYes,
          funcNo: ""
        };

        this.$store.dispatch("showAlert", obj);
        
      }
    },
    selectResource(revisionId) {
     
      /*
            
      let actionButtons = document.querySelectorAll(".actionButtonFolder");
      
      
      for(let button of actionButtons){
        
        if (this.revisionId == revisionId) {
          
          // if (this.model.type == "folder") {
          //   id = "id_" + this.model.folderId + "_" + this.revisionId;
          // }
          
          // if (this.model.type == "file"){
          //   id = "id_" + this.model.fileId + "_" + this.revisionId;
          // }
          let id = "id_" + this.itemId + "_" + this.revisionId;

          
          if (button.id === id && button.id !== 1) {
            
                        
            button.style.display = "inline";
            
          }
          if (id !== button.id) {
            
            button.style.display="none";
            
          }
          
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItem", this._uid);
      
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItemObject", this.model);

          if (this.action == true){
            
            this.$store.dispatch(this.$store.getters.sectionPrefix + "_setElementFolderProject", this.model.category);
            
          }
        }
        
          
      }*/
      let dropdownMore = document.querySelectorAll(".dropdown-more");
      
      for (let button of dropdownMore) {

        if (this.revisionId == revisionId) {

          
          let id = "id_" + this.itemId + "_" + this.revisionId;


          if (button.id === id && button.id !== 1) {


            button.style.display = "inline";
            
          }
          if (id !== button.id) {
            
            //button.style.display = "none";
            
          }

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItem", this._uid);

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItemObject", this.model);

          if (this.action == true) {

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_setElementFolderProject", this.model.category);

          }
        }


      }
      

    },
    changeType: function () {
        if (!this.isFolder) {
            Vue.set(this.model, 'children', []);
            this.addChild();
            this.open = true;
        }
    }

  }
}
</script>


<style lang="scss">
.ItemTreeFolder{
    .expandimage {
      width: 16px;
      height: 16px;
      margin-left: 5px;
      margin-right: 5px;
    }
    .expand__container{
      width:20px;
      height: 15px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-direction: column;
    }
    .library_item {
      cursor: pointer;

    }
    .library_ul {
      padding-left: 18px;
      line-height: 1.5em;
      list-style-type: none;

    }
    .library_ul_flat {
      padding-left: 0px;
      line-height: 1.5em;
      list-style-type: none;

    }
    .actionButton{
      margin-left: 3px;
      border-radius: 3px;
      border: 1px solid white;
    }
    .category__name{
      cursor: pointer;
      white-space: nowrap;
    }
    .folder{
      background-image: url("/static/folder.svg");
      width: 19px;
      height: 16px;
      //display: block;
      margin-right: 5px;
    }
    .folder-variant{
      background-image: url("/static/folder-variant.svg");
      width: 19px;
      height: 16px;
      //display: block;
      margin-right: 5px;
    }
    .nofolder{
        background-image: url("/static/file_grey.png");
        width: 19px;
        height: 16px;
        //display: block;
        margin-right: 5px;
        float: left;
    }

    .treeline{
      display: inline-flex;
      height: 18px;
      img{
        margin-right: 5px;
      }
    }

    a{
      padding-right: 10px;
      padding-left: 10px;
    }
    .active {
      //margin-left: 5px;
      margin-right: 5px;
      white-space: nowrap;
      //margin-top: 1px;
      //margin-bottom: 1px;
    }
    .actionButton{
      float: left;
    }
    .badge-file-rev{
      padding: 2px;
    }
    .badge-delegate{
      padding: 2px;
      margin: 1px;
    }
    .dropdown-more{
      height: 18px;
      
      .btn{
        height: 18px;
        margin-top: -2px;
      }
      .btn-sm, .btn-group-sm>.btn {
          padding: 0px 3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/ItemTreeFolder.vue